// extracted by mini-css-extract-plugin
export default {"wrapper":"ldSCPjUInm7IqYVWNY4Jsg==","label":"CgmK422TszNE66lsIGd-MA==","smsLabel":"bJKWVGQOTg3Ko7LJs3I2lg=="};